import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidate|Exams|Create|';

export type SPCandidateExamCreateLoc =
	| 'SPCandidateExamCreateAutoRegId'
	| 'SPCandidateExamCreateFormField'
	| 'SPCandidateExamCreateVersionField'
	| 'SPCandidateExamCreateScoreField'
	| 'SPCandidateExamCreateCorrectItemsField'
	| 'SPCandidateExamCreateIncorrectItemsField'
	| 'SPCandidateExamCreateExamCommentField'
	| 'SPCandidateExamLabelAuthId';

export const spCandidateExamCreateLocs: LocDefs<SPCandidateExamCreateLoc> = {
	SPCandidateExamCreateAutoRegId: {
		defaultValue: 'Auto Generated',
		description: 'Text displayed in the registration number field when it is auto-generated.',
		displayPath: `${dpRoot}Auto Registration Number Value`,
		displayType: 'Content',
		feature: HubFeature.ExamAutoGenerateRegistrationNumber,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamCreateFormField: {
		defaultValue: 'Form',
		description: 'Label for the form field.',
		displayPath: `${dpRoot}Form Field`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamCreateVersionField: {
		defaultValue: 'Version',
		description: 'Label for the version field.',
		displayPath: `${dpRoot}Version Field`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamCreateScoreField: {
		defaultValue: 'Score',
		description: 'Label for the score field.',
		displayPath: `${dpRoot}Score Field`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamCreateCorrectItemsField: {
		defaultValue: 'Number of Correct Items',
		description: 'Label for the number of correct items field.',
		displayPath: `${dpRoot}Number of Correct Items Field`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamCreateIncorrectItemsField: {
		defaultValue: 'Number of Incorrect Items',
		description: 'Label for the number of incorrect items field.',
		displayPath: `${dpRoot}Number of Incorrect Items Field`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamCreateExamCommentField: {
		defaultValue: 'Exam Comment',
		description: 'Label for the exam comment field.',
		displayPath: `${dpRoot}Exam Comment Field`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
		htmlAllowed: false,
	},
	SPCandidateExamLabelAuthId: {
		defaultValue: 'Exam Authorization ID',
		description: 'Label for the authorization ID field.',
		displayPath: `${dpRoot}Authorization ID Field`,
		displayType: 'Label',
		feature: HubFeature.ExamAuthorization,
		portal: 'SP',
		htmlAllowed: false,
	},
};

export const spCandidateExamCreateLocKeys =
	MapLocKeys<SPCandidateExamCreateLoc>(spCandidateExamCreateLocs);

export type SPCandidateExamCreateLocMap = LocMap<SPCandidateExamCreateLoc>;
